import { render, staticRenderFns } from "./GoodsSizeEdit.vue?vue&type=template&id=2f87040e&"
import script from "./GoodsSizeEdit.vue?vue&type=script&lang=js&"
export * from "./GoodsSizeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports